"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Footer_1 = require("@reactionable/core/lib/ui/layout/footer/Footer");
const Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
const Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
const Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
function Footer(_a) {
    var { brand, sponsor = true } = _a, footerProps = tslib_1.__rest(_a, ["brand", "sponsor"]);
    footerProps.style = Object.assign({ position: "absolute", bottom: 0, width: "100vw", height: "60px", lineHeight: "60px" }, footerProps.style);
    return (jsx_runtime_1.jsx("footer", Object.assign({}, footerProps, { children: jsx_runtime_1.jsx(Container_1.default, { children: jsx_runtime_1.jsxs(Row_1.default, Object.assign({ className: "justify-content-between" }, { children: [jsx_runtime_1.jsx(Col_1.default, { children: jsx_runtime_1.jsx(Footer_1.CopyrightFooter, { brand: brand }, void 0) }, void 0),
                    sponsor && (jsx_runtime_1.jsx(Col_1.default, Object.assign({ className: "text-right" }, { children: jsx_runtime_1.jsx(Footer_1.SponsorFooter, {}, void 0) }), void 0))] }), void 0) }, void 0) }), void 0));
}
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map